import { OAuthStorage } from "angular-oauth2-oidc";

export class LocalStorageWrapper implements OAuthStorage {
  getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  setItem(key: string, data: string): void {
    localStorage.setItem(key, data);
  }
}
